import { render, staticRenderFns } from "./driverVehicleForm.vue?vue&type=template&id=2e1a7c91&scoped=true&"
import script from "./driverVehicleForm.vue?vue&type=script&lang=js&"
export * from "./driverVehicleForm.vue?vue&type=script&lang=js&"
import style0 from "./driverVehicleForm.vue?vue&type=style&index=0&id=2e1a7c91&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a7c91",
  null
  
)

export default component.exports